export function routeRedirect(path: string) {
  return () => {
    // is a path
    if (path[0] === '/') {
      return path;
    }
    // is external url
    window.location = path;
  };
}
